module.exports = __webpack_public_path__ + "static/media/img_login.77cf4182.png";